export { ConsentPage } from "./ui/consent-page"
